<template>
    <div class="data-market">
        <div class="box">
        <div class="tab-container">
            <div :class="['tab', {active: tab===0}]" 
                @click="onChangeTab(0)">
                作答中心
            </div>
            <div :class="['tab', {active: tab===1}]" 
                @click="onChangeTab(1)">
                作答记录
            </div>
        </div>    
        </div>
        <div class="data-market-table">
            <div class="content" v-show="tab === 0">
                <!-- 单栏布局 -->
                <market-table
                    v-if="!(isOpenAlliance === 1 && allianceLayout === 3)"
                    :list="isOpenAlliance === 0 ? tableList : unionList"
                    :total="isOpenAlliance === 0 ? tableTotal : unionTotal"
                    @init="initSingleList"
                ></market-table>
                <!-- 双栏布局 -->
                <div class="double-inner" v-if="isOpenAlliance === 1 && allianceLayout === 3">
                    <!-- 左 - 作答中心问卷 -->
                    <div class="inner">
                        <market-table
                            :list="tableList"
                            :total="tableTotal"
                            @init="initTableList"
                        ></market-table>
                    </div>
                    <!-- 右 - Credamo见数问卷 -->
                    <div class="inner">
                        <market-table
                            :list="credamoList"
                            :total="credamoTotal"
                            @init="initCredamoList"
                        ></market-table>
                    </div>
                </div>
            </div>
            <!-- 作答记录 -->
            <record-table 
                v-show="tab === 1"
                :list="tableList"
                :total="tableTotal"
                @init="onInitTableList"
            ></record-table>
        </div>
    </div>
</template>

<style scoped>
.data-market{
    background: #f5f5f5;
}
.box{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 95px;
}
.tab-container{
    background: #fff;
    border: 1px solid var(--theme);
    border-radius: 30px;
    margin: 0 auto;
}
.tab{
    width: 164px;
    line-height: 50px;
    text-align: center;
    border-radius: 30px;
    display: inline-block;
    cursor: pointer;
}
.tab.active{
    width: 210px;
    background: var(--theme);
    color: #fff;
}
.data-market-table{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.content{
    width: 100%;
}
.double-inner{
    width: 1200px;
    display: flex;
    justify-content: space-between;
}
.double-inner .inner{
    width: 49%;
}
</style>

<script>
import { DataMarket } from '@/models/data-market'
import MarketTable from '@/components/data-market/table.vue'
import RecordTable from '@/components/data-market/record-table.vue'
export default {
    name: 'PCDataMarket',
    data(){
        return {
            tab: 0,
            pageIndex: 1,
            pageSizeA: 10,
            pageSizeB: 10,
            tableList: [],
            tableTotal: 0,
            credamoList: [],
            credamoTotal: 0,
            isOpenAlliance: 0,
            allianceLayout: 0,
        }
    },
    components: {
        MarketTable,
        RecordTable
    },
    computed: {
        unionList(){
            if(this.allianceLayout === 3){
                if(!this.tableList || !this.credamoList){
                    this.allianceLayout = 1
                    return
                }
            }else if(this.allianceLayout === 1){
                return this.tableList.concat(this.credamoList)
            }else{
                return this.credamoList.concat(this.tableList)
            }
        },
        unionTotal(){
            // return this.tableTotal + this.credamoTotal
            if(this.tableTotal > this.credamoTotal){
                return this.tableTotal
            }else{
                return this.credamoTotal
            }
        }
    },
    created () {
        this.init()
    },
    methods: {
        init(){
            // 请求联盟配置JSON
            DataMarket.getAllianceConfig().then(res => {
                if(res) {
                    this.isOpenAlliance = res.isOpenAlliance;
                    this.allianceLayout = res.allianceLayout;
                    this.getData(1)
                }else{
                    this.getData(1)    
                }
            })
        },
        getData(page){
            if(this.isOpenAlliance === 0){
                this._getDataMarket(page)
            }else if(this.isOpenAlliance === 1 && this.allianceLayout === 3){
                this._getDataMarket(page)
                this._getDataCredamo(page)
            }else{
                this.getUnionData(page)
            }
        },
        async getUnionData(pageIndex){
            this.pageSizeA = 5
            await this._getDataMarket(pageIndex)
            
            const tmp = this.tableTotal - pageIndex*5 + 5
            if(tmp >= 5){
                this.pageSizeB = 5
            }else if(tmp > 0 && tmp < 5){
                this.pageSizeB = 10 - tmp
            }else{
                this.pageSizeB = 10
            }
            await this._getDataCredamo(pageIndex)
        },
        onChangeTab(index){
            if(this.tab === index){
                return
            }
            this.pageIndex = 1
            this.tab = index
            this.onInitTableList(this.tab, this.pageIndex)
        },
        onInitTableList(tab, page){
            if(tab === 0){
                this.getData(page)
            }else{
                this._getAnswerRecords(page)
            }
        },
        initSingleList(page){
            this.getData(page)
        },
        initTableList(page){
            this._getDataMarket(page)
        },
        initCredamoList(page){
            this._getDataCredamo(page)
        },
        _getDataMarket(pageIndex){
            return DataMarket.getDataMarket(this.pageSizeA,pageIndex).then(res => {
                this._handleTableList(res)
                return res
            })
        },
        _getDataCredamo(pageIndex){
            return DataMarket.getDataCredamo(this.pageSizeB,pageIndex).then(res => {
                if(res.success){
                    this.credamoList = res.data;
                    this.credamoTotal = res.total;
                    return res
                }else{
                    this.$alert(res.message, '提示', {
                        type: 'error'
                    })
                }
            })
        },
        _getAnswerRecords(pageIndex){
            DataMarket.getAnswerRecords(pageIndex).then(res => {
                this._handleTableList(res)
            })
        },
        _handleTableList(res){
            if(res.success){
                this.tableList = res.data;
                this.tableTotal = res.total;
            }else{
                this.$alert(res.message, '提示', {
                    type: 'error'
                })
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/content/data-market.vue